import script from "./EventsSide.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsSide.vue?vue&type=script&lang=ts&setup=true"

import "./EventsSide.vue?vue&type=style&index=0&id=ece2de52&scoped=true&lang=css"
/* custom blocks */
import block0 from "./EventsSide.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ece2de52"]])

export default __exports__